import type {DiffLine} from '@github-ui/diff-lines'
import {PageData} from '@github-ui/pull-request-page-data-tooling/page-data'
import type {QueryKey} from '@github-ui/react-query'
import {reactFetch} from '@github-ui/verified-fetch'

export type ContextLineRange = {
  start: number
  end: number
}

export type ContextLineResponse = {
  diffEntryLines?: DiffLine[]
}

export function diffContextLinesKey(basePath: string, path: string, baseOid: string, headOid: string): QueryKey {
  return [PageData.diffContextLines, basePath, path, baseOid, headOid]
}

/**
 * Fetches the context lines for a given diff entry
 */
export async function fetchInjectedContextLines(
  contextLineRanges: ContextLineRange[],
  url: string,
  path: string,
  w: string = '0', // Add w parameter, default to '0'
): Promise<ContextLineResponse | undefined> {
  const params = new URLSearchParams()
  params.append('path', path)
  for (const contextLineRange of contextLineRanges) {
    params.append('context_line_ranges[]', JSON.stringify(contextLineRange))
  }
  params.append('w', w) // Use the provided w value
  const baseFetchUrl = `${url}?${params.toString()}`
  const response = await reactFetch(baseFetchUrl)

  if (response.ok) {
    const data = await response.json()
    return data ?? undefined
  }
}
